//purpose of this file is to record what users do, logEvent is the only way in and fills in who did it, their role, the date and a timestamp
//it writes one row to Events and updates that day's counters in Stats, see src/util/eventTypes.js for the allowed types

import firebase from "firebase";
import { db, auth } from "../db";
import { eventTypes, isKnownEventType } from "../util/eventTypes";

function dayKey(date) {
  return date.toISOString().split("T")[0];
}

function toRoleCode(raw) {
  if (raw === null || raw === undefined || raw === "") return null;
  const code = Number(raw);
  return Number.isNaN(code) ? null : code;
}

function storedRole() {
  try {
    return toRoleCode(window.localStorage.getItem("userType"));
  } catch (e) {
    return null;
  }
}

function currentRole(meta) {
  const fromMeta = toRoleCode(meta.userType);
  return fromMeta === null ? storedRole() : fromMeta;
}

//stores the user's ID in a map rather than incrementing a number, since counters measure actions but we need people
//writing the same ID twice is harmless, so this needs no read first and never conflicts when writes land at once
function markUserSeen(day, userID, rollup) {
  return db
    .collection("Stats")
    .doc(day)
    .set({ [`${rollup}Ids`]: { [userID]: true } }, { merge: true });
}

//records one action, throwing on unknown types in development but only logging in production so it cannot break a user's flow
//never awaited anywhere and catches its own failures, so tracking cannot slow down or break the action it records
function logEvent(type, meta = {}) {
  if (!isKnownEventType(type)) {
    const error = new Error(`Unknown event type "${type}". Add it to src/util/eventTypes.js`);
    if (process.env.NODE_ENV !== "production") throw error;
    console.error(error.message);
    return Promise.resolve({ success: false, error: error.message });
  }

  const userID = auth.currentUser ? auth.currentUser.uid : null;
  const userType = currentRole(meta);
  const day = dayKey(new Date());
  const declared = eventTypes[type].rollup;
  const rollup = typeof declared === "function" ? declared(meta, userType) : declared;

  const writes = [
    db.collection("Events").add({
      type,
      userID,
      userType,
      day,
      meta,
      timestamp: firebase.firestore.FieldValue.serverTimestamp(),
    }),
  ];

  if (userID) {
    [].concat(rollup || []).forEach((metric) => {
      writes.push(markUserSeen(day, userID, metric));
    });
  }

  return Promise.all(writes)
    .then(() => ({ success: true }))
    .catch((e) => {
      console.error(`logEvent("${type}") failed:`, e);
      return { success: false, error: e };
    });
}

export default {
  logEvent,
};



// WEBPACK FOOTER //
// ./src/Firestore/Events.js